import { render, staticRenderFns } from "./substitutionExamine.vue?vue&type=template&id=47d24b5c&"
import script from "./substitutionExamine.vue?vue&type=script&lang=js&"
export * from "./substitutionExamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports